import React from 'react';
import { useLanguage } from '../context/LanguageContext';
export function Marquee() {
  const {
    t
  } = useLanguage();
  const loop = [...t.marquee, ...t.marquee];
  return <section aria-hidden className="bg-texture-espresso text-cream border-y border-cream/10 py-8 overflow-hidden" data-id="element-176">
      <div className="flex whitespace-nowrap animate-marquee" data-id="element-177">
        {loop.map((w, i) => <div key={i} className="flex items-center px-10 shrink-0" data-id="element-178">
            <span className="font-serif italic text-3xl lg:text-4xl text-cream/85 font-light" data-id="element-179">
              {w}
            </span>
            <span className="mx-10 w-1.5 h-1.5 rounded-full bg-caramel shrink-0" data-id="element-180" />
          </div>)}
      </div>
    </section>;
}